import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { ReferenceScheme } from 'src/app/reference-scheme/models/reference-scheme.model';
import { Product } from 'src/app/shared/models/shared.model';

import { FeedAdvice } from '../models/feed-advice.models';

/*** Clear State. ***/
export const clearFeedAdviceState = createAction('[Feed-Advice] Clear feed-advice State');

/*** Load Data. ***/
export const loadData = createAction('[Feed-Advice] Load data');
export const loadFeedAdvicesRequest = createAction('[Feed-Advice] Load feed-advices request');
export const loadFeedAdvicesSuccess = createAction(
  '[Feed-Advice] Load feed-advices success',
  props<{ feedAdvices: FeedAdvice[] }>(),
);
export const loadFeedAdvicesFailed = createAction(
  '[Feed-Advice] Load feed-advices failed',
  props<{ error: HttpErrorResponse }>(),
);

/*** Upsert Actions. ***/
export const upsertFeedAdviceRequest = createAction(
  '[Feed-Advice] Upsert feed-advice request',
  props<{ feedAdvice: FeedAdvice }>(),
);
export const upsertFeedAdviceSuccess = createAction(
  '[Feed-Advice] Upsert feed-advice success',
  props<{ feedAdvice: FeedAdvice }>(),
);
export const upsertFeedAdviceFailed = createAction(
  '[Feed-Advice] Upsert feed-advice failed',
  props<{ error: HttpErrorResponse }>(),
);

/*** Navigation Actions. ***/
export const createFromReferenceAdviceNavigation = createAction(
  '[Feed-Advice] Create advice from reference navigation',
);
export const createAdviceNavigation = createAction('[Feed-Advice] Create advice navigation');
export const editAdviceNavigation = createAction(
  '[Feed-Advice] Edit advice navigation',
  props<{ feedAdvice: FeedAdvice }>(),
);
export const viewAdviceNavigation = createAction(
  '[Feed-Advice] View advice navigation',
  props<{ feedAdvice: FeedAdvice }>(),
);

/*** DELETE ***/
export const deleteAdviceConfirm = createAction(
  '[Feed-Advice] Delete advice confirm',
  props<{ feedAdvice: FeedAdvice }>(),
);

export const deleteAdviceRequest = createAction(
  '[Feed-Advice] Delete advice request',
  props<{ feedAdviceId: number }>(),
);

export const deleteAdviceSuccess = createAction(
  '[Feed-Advice] Delete advice success',
  props<{ feedAdviceId: number }>(),
);

export const deleteAdviceFailed = createAction(
  '[Feed-Advice] Delete advice failed',
  props<{ error: HttpErrorResponse }>(),
);

export const loadProductsByCountryRequest = createAction(
  '[Feed-Advice] Load products by selected country request',
);
export const loadProductsByCountrySuccess = createAction(
  '[Feed-Advice] Load products by selected country success',
  props<{ products: Product[] }>(),
);
export const loadProductsByCountryFailed = createAction(
  '[Feed-Advice] Load products by selected country failed',
  props<{ error: HttpErrorResponse }>(),
);

export const loadReferenceSchemesByCountryRequest = createAction(
  '[Feed-Advice] Load reference schemes by selected country request',
);
export const loadReferenceSchemesByCountrySuccess = createAction(
  '[Feed-Advice] Load reference schemes by selected country success',
  props<{ referenceSchemes: ReferenceScheme[] }>(),
);
export const loadReferenceSchemesByCountryFailed = createAction(
  '[Feed-Advice] Load reference schemes by selected country failed',
  props<{ error: HttpErrorResponse }>(),
);

export const setBaseFeedAdviceRequest = createAction(
  '[Feed-Advice] Set base feed advice request',
  props<{ feedAdvice: FeedAdvice }>(),
);
export const setBaseFeedAdviceSuccess = createAction(
  '[Feed-Advice] Set base feed advice success',
  props<{ feedAdvice: FeedAdvice }>(),
);
export const setBaseFeedAdviceFailed = createAction(
  '[Feed-Advice] Set base feed advice failed',
  props<{ error: HttpErrorResponse }>(),
);
